export { default } from './Heading';
export { APPEARANCES, SIZE } from './Heading';
